import { useEditor } from "@grapesjs/react";
import AiAssistantPopup from "./AiAssistantPopup";

function AiAssistantWithEditor() {
  const editor = useEditor(); 

  return <AiAssistantPopup editor={editor} />;
}

export default AiAssistantWithEditor;
